import { useMutation } from 'react-query';
import { RemoteLicensesRepo } from '@repository/licenses/LicensesRepo';
import { LicenseVO } from '@domain/vo/profile/ProfileSkillVO';

const remoteLicensesRepo = new RemoteLicensesRepo();

const fetchLicenses = async (keyword: string) => {
  const { data } = await remoteLicensesRepo.fetchLicenses(keyword);
  return data.licenses.map((item) => new LicenseVO(item));
};

export default function useLicenses() {
  return useMutation((keyword: string) => fetchLicenses(keyword));
}
